import { render, staticRenderFns } from "./DesktopMyPage.vue?vue&type=template&id=4bc97208&scoped=true"
import script from "./DesktopMyPage.vue?vue&type=script&lang=js"
export * from "./DesktopMyPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopMyPage.vue?vue&type=style&index=0&id=4bc97208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc97208",
  null
  
)

export default component.exports